import { Stack } from '@mui/material';
import type { CreditLedgerEntryOverview } from '@vy/types';
import { sortBy } from 'lodash';
import { useMemo } from 'react';
import { VyTable } from '../../../../../components/new-design/table/vy-table/VyTable';
import type { VyTableMinimalProps } from '../../../../../components/new-design/table/vy-table/vy-table-types';
import { CREDIT_LEDGER_OVERVIEW_TABLE_COLUMNS } from './credit-ledger-overview-columns';

type CreditLedgerOverviewTableProps = Omit<VyTableMinimalProps<CreditLedgerEntryOverview>, 'tableName'>;

export const CreditLedgerOverviewTable: React.FC<CreditLedgerOverviewTableProps> = ({
  items,
  ...props
}) => {
  const sortedEntriesByDate = useMemo(() => sortBy<CreditLedgerEntryOverview>(items, 'date'), [items]);

  return (
    <Stack sx={{ height: '100%', width: '100%', maxHeight: 500 }}>
      <VyTable
        tableName="credit-ledger"
        columns={CREDIT_LEDGER_OVERVIEW_TABLE_COLUMNS}
        items={sortedEntriesByDate}
        showPagination={false}
        {...props}
        sx={{
          padding: '10px',
          border: 'auto',
          height: '100%',
          paddingBottom: 0,
        }}
      />
    </Stack>
  );
};
